
import { curry } from 'lodash'

const reportsSelector = (state) => state.report.nvqual.reports
const filtersSelector = (state) => state.report.nvqual.filters
const loadingSelector = (state) => state.report.nvqual.isLoading
const querySelector = curry((state, value) => {
  return state.report.nvqual.query[value].query
})

const queryInputSelector = curry((state, value) => {
  if (!state.report.nvqual.query[value]) return
  let values = state.report.nvqual.query[value].input
  let selection = [] 
  values.forEach(value => {
    selection.push(value.value)
  })
  return selection
})

const querySourceSelector = curry((state, value) => {
  if (!state.report.nvqual.query[value]) return
  const source = state.report.nvqual.query[value].source
  return Object.values(source)
})

const chartStateSelector = curry((state, value) => {
  if (!state.report.nvqual.chartState[value]) return
  const val = state.report.nvqual.chartState[value]
  return val
})


export {
  reportsSelector,
  filtersSelector,
  querySelector,
  queryInputSelector,
  querySourceSelector,
  chartStateSelector,
  loadingSelector
}